module.exports = __webpack_public_path__ + "img/Microsoft.a194c05.svg";